import { Layout } from 'antd';
import styled from 'styled-components';

export const Container = styled(Layout)`
  display: flex;
  margin-inline-start: 107px;
  margin-inline-end: 50px;
`;
